import React, { useEffect, useState } from "react";
import { SelectorViewer } from "./SelectorViewer";
import { ComplexSelector } from "./ComplexSelector";
import { BreadcrumbHeader } from "../../navigation";
import { ProductsList } from "./ProductsList";
import { ActionPanel, BusyContainer, SvgImage } from "../../../../components";
import { ConfiguratorSelectorViewer } from "./ConfiguratorSelectorViewer";
import { configuratorActions, flagActions, productActions, superCodeActions, translate } from "../../../../services";
import { infoIconBlue, newExpandButton } from "../../../../../style/images";
import classNames from "classnames";
import { ConfiguratorPage } from "../ConfiguratorPage";
import { AppStore, showConfigureDispatcher } from "../../../../store";
import { Box } from "@mui/material";

const ConfigurationComponent = (props)=>{
  return React.Children.map(props.children, child=>React.cloneElement(child, props))
}

const ProductsListComponentMemo = React.memo(({totalFilterCount, isConfigurable, resetHeader, currentSelector, onConfigureRequest})=>{
  const ProductsListComponent = ProductsList( currentSelector.selector.name );
  return <ProductsListComponent view={isConfigurable?"modelconfiguratorproduct":"product"} resetHeader = {resetHeader} currentSelector={ currentSelector } onConfigureRequest={ onConfigureRequest } fromConfiguratorSelector={true}/>
})

export const ModelConfiguratorSelectorView = (props, context)=>{

    const { currentSelector, onConfigureRequest, siteSettings } = props;

    const [filterCount, setFilterCount] = useState(0);
    const [totalFilterCount, setTotalFilterCount] = useState(0);
    const [isExpanded, setIsExpanded] = useState(true);

    const [currentProduct, setCurrentProduct] = useState("");
    const [totalItems, setTotalItems] = useState(0);

    const [ConfiguratorComponent, setConfiguratorComponent] = useState(false);

    const [isConfigurable, setIsConfigurable] = useState(false);

    const [activeTab, setActiveTab] = useState("Configurator");

    const[selectedAccessorySelections, setSelectedAccessorySelections] = useState([]);

    const[mainProductChanged, setMainProductChanged] = useState(false);

    useEffect(()=>{
      
      if(totalItems){
        if(isConfigurable !== totalItems.results?.any(product=>product.materialName && product.materialName !== product.name))
          {setIsConfigurable(totalItems.results?.any(product=>product.materialName && product.materialName !== product.name));}
      }
      if(totalItems?.results?.length!==1){
        setCurrentProduct("")
        setConfiguratorComponent(false)
      }
      if(totalItems?.results?.length===1 && (!currentProduct || currentProduct.name!==totalItems?.results[0].name)){
        let selectedAccessories = sessionStorage.getItem("selectedAccessorySelections")
        if(totalItems?.results[0].name===sessionStorage.getItem("currentSelectedProduct") && selectedAccessories && selectedAccessories!=="null"){
          setSelectedAccessorySelections(JSON.parse(selectedAccessories));
        }
        setCurrentProduct(totalItems?.results[0])
        setConfiguratorComponent(true)
      }
    },[totalItems])

    // useEffect(()=>{
    //   if(currentProduct){
    //     openConfigurationPopup(currentProduct)
    //   }

    // },[currentProduct])
    const removeExcessPropertiesFromProduct = product => ({ 
      ...product, 
      preset: product.bomItems?.select( b => ({ variableName: b.identifier.split('.').slice(1).join('.'), valueName: b.value.name })), 
      bomItems: undefined,
      allSatisfied: undefined,
      hideConfigureButton: true,
    });

    const handleSelectedAccessorySelections = (selection, type) =>{
      setMainProductChanged(false);
      if(type==="add"){
        let index = selectedAccessorySelections.findIndex(v=>v.key===selection.key);
        let newArray = [...selectedAccessorySelections];
        if(index!==-1){
          newArray[index] = selection;
        }
        else{
          newArray.push(selection);
        }
        newArray.sort((a,b)=>a.index-b.index);
        sessionStorage.setItem("selectedAccessorySelections", JSON.stringify(newArray))
        sessionStorage.setItem("currentSelectedProduct", currentProduct.name)
        setSelectedAccessorySelections(newArray);
      }
      if(type==="remove"){
        let position = selectedAccessorySelections.findIndex(v=>v.key===selection.key);
        let newArray = [...selectedAccessorySelections];
        newArray.splice(position, 1)
        sessionStorage.setItem("selectedAccessorySelections", JSON.stringify(newArray))
        sessionStorage.setItem("currentSelectedProduct", currentProduct.name)
        setSelectedAccessorySelections(newArray);
      }

      if(type==="update"){
        sessionStorage.setItem("selectedAccessorySelections", JSON.stringify(selection))
        sessionStorage.setItem("currentSelectedProduct", currentProduct.name)
        setSelectedAccessorySelections(selection);
      }
    }

   const openConfigurationPopup = (product, showOnlySelectors, showOnlyAccessoriesList, showOnlyFooter) => {
      // if(this.props.currentPage.currentPage!=="configuratorPage"){
      //   this.props.setPage("configuratorPage")
      // }
      //for mobile
      
      const modelToLoad = props.currentSelector.selector.modelToLoad || props.currentNode.customProperties && props.currentNode.customProperties.modelToLoad ;
      
      const filterSelectors = totalItems?.request?.filterGroups;
      
      const properties = {
        ...props.currentNode.customProperties,
        ...totalItems.request.metaData
      }

      const oldProduct = { ...product, hideConfigureButton: true };
      let title = `${translate( 'Configure {product}', { product: product.code} )}`;
      

      return <ConfiguratorPage  
            properties={ properties || product.usCodeProps } 
            modelToLoad={ modelToLoad} 
            product={ removeExcessPropertiesFromProduct( product ) } 
            oldProduct={ oldProduct } 
            isPopup 
            selector
            filterSelectors={ filterSelectors }
            fromModelConfiguratorSelector
            showOnlySelectors = {showOnlySelectors}
            showOnlyAccessoriesList = {showOnlyAccessoriesList}
            showOnlyFooter = {showOnlyFooter}
            selectedAccessorySelections={selectedAccessorySelections}
            handleSelectedAccessorySelections={handleSelectedAccessorySelections}
            mainProductChanged = {mainProductChanged}
            setMainProductChanged = {setMainProductChanged} />
      
      // this.props.captureEvent( 'configured-items', 'family', product.materialName, ['commonTracker'] );
      //   //ga4
      //   const additionalProduct = product.bomItems?.firstOrDefault(x => x.identifier.indexOf('FixedPart') > 0);
      //   if (this.props.currentPage.currentPage!="cartPage") { 
      //   const eventString = product.bomItems?(";"+product.bomItems?.reduce((s,b)=>s!=""?s+","+b.value.name:b.value.name,"")):"";
      //   dataLayer.push({
      //     'event': 'configured_items',
      //     event_action:'family',
      //     event_label :(additionalProduct?"FP+MP:":"")+product.name.concat(eventString).concat(':').concat(product.materialName),
      //     event_instance:this.props.siteSettings.properties.GaInstance,
      //     event_country: this.props.siteSettings.properties.GaCountry,
      //     location_url:window.location.href
      //   })
      // }
      // else { //configuration from cart
      //   const cartProduct = product.configuration&&product.configuration.model&&product.configuration.model.children[0]&&product.configuration.model.children[0].variables?product.configuration.model.children[0].variables:""; //for retrieving accessories FP
      //   const cartProductMP = product.additionalProducts&&product.additionalProducts.length>0&&product.additionalProducts[0].configuration? product.additionalProducts[0].configuration?.model.children[0].variables:""; //for retrieving accessories MP
      //   const finalProd=cartProduct!=""?cartProduct.reduce((s,b)=>b.assignedValue!=null? (s!=""? s+","+b.assignedValue.name: b.assignedValue.name):s,""):""; //create string accessories FP
      //   const finalProdMP=product.additionalProducts&&product.additionalProducts.length>0 && cartProductMP!=""?cartProductMP.reduce((s,b)=>b.assignedValue!=null? (s!=""? s+","+b.assignedValue.name: b.assignedValue.name):s,""):""; //create string accessories MP
      //   const eventString = (product.additionalProducts&&product.additionalProducts.length>0?"FP+MP:":"")+product.name+((finalProd!=""?";"+finalProd:"")+(product.additionalProducts&&product.additionalProducts.length>0?("-"+product.additionalProducts[0].name+(finalProdMP!=""?";"+finalProdMP:"")):""))+':'+(product.materialName);
      //   dataLayer.push({ //for cart
      //     'event': 'configured_items',
      //     event_action:'family',
      //     event_label :eventString,
      //     event_instance:this.props.siteSettings.properties.GaInstance,
      //     event_country: this.props.siteSettings.properties.GaCountry,
      //     location_url:window.location.href
      //   })
      // }
    }
    const updateFilterCount=(count)=>{
        setFilterCount(count);
      }

    const updateTotalFilterCount = (count) =>{
        setTotalFilterCount(count);
    }
    
    const handleExpand = ()=>{
      setIsExpanded(!isExpanded);
    }

    const handleActiveTab = (activeTab) =>{
      setActiveTab(activeTab);
    }
    const getSelectorComponent = () => {
      const { currentSelector, onSelectorChanged, parentSelector} = props;
  
      if ( parentSelector && parentSelector.isComplexSelector ) {
        if( !currentSelector.modelToLoad ) {
          currentSelector.modelToLoad = parentSelector.complexSelector.configurations.firstOrDefault( conf => conf.name === parentSelector.name ).targetSelector;
        }
  
        return <ComplexSelector 
          selector={ parentSelector } 
          Component={SelectorViewer} 
          onSelectorChanged={ onSelectorChanged } 
          currentSelector={ currentSelector.selector }  updateTotalFilterCount={updateTotalFilterCount} updateFilterCount={updateFilterCount} totalFilterCount={totalFilterCount} filterCount={filterCount} resetHeader={props.resetHeader} showResetHeader={props.showResetHeader} setShowResetHeader={props.setShowResetHeader}
        />;
      }
  
      const SelectorViewerComponent = ConfiguratorSelectorViewer( currentSelector.selector.name );
      return <SelectorViewerComponent currentSelector={ currentSelector.selector }  updateTotalFilterCount={updateTotalFilterCount} updateFilterCount={updateFilterCount} totalFilterCount={totalFilterCount} filterCount={filterCount} resetHeader={props.resetHeader} showResetHeader={props.showResetHeader} setShowResetHeader={props.setShowResetHeader} setTotalItems = {setTotalItems}/>;
    }

      return <BusyContainer 
          className="model-configurator-selection-panel" 
          actions={ 
            [
              configuratorActions.ASSIGN,
              configuratorActions.RESET,
              configuratorActions.REMOVE,
              configuratorActions.LOADED,
              configuratorActions.FROMTEMPLATE,
              superCodeActions.CREATE,
              productActions.GET,
              productActions.LOAD,
              flagActions.ADDING,
              'filter-active'
            ]}>
            <div className="model-configurator-selector">
              <div className="model-configurator-header-mobile">
                <div className={classNames("tab-header", {active:activeTab==="Configurator"})} onClick={()=>{handleActiveTab("Configurator")}}>{translate("Configurator")}</div>
                <div className={classNames("tab-header", {active:activeTab==="Products"})} onClick={()=>{handleActiveTab("Products")}}>{translate("Products")}</div>
              </div>
              <div className={classNames('model-configurator-content',{"with-footer":isConfigurable && ConfiguratorComponent})}>
                <div className={classNames("col-4 model-configurator-selectors",{"hide":activeTab!=="Configurator"})}>
                  {/* filters will go here  */}
                  {isConfigurable && !ConfiguratorComponent && <div className="selection-info">
                      <Box component="img" src={infoIconBlue}/>
                      <span>{translate("Select all components in selector to see add-ons")}</span>
                    </div>}
                  <div className="selector-header-container">
                  {<SvgImage source={ newExpandButton } className={classNames("expander-icon",{'expanded':isExpanded})} onClick={handleExpand}></SvgImage>}
                    <span className="selector-header">
                      <span>{translate("Selectors")}</span>
                      {props.resetHeader && <>{props.resetHeader.map(e=>e.customHeader)}</>}
                      </span>
                  </div>
                  {isExpanded && getSelectorComponent() }
                  {/* {ConfiguratorComponent && <ConfigurationComponent fromModelConfiguratorSelector showOnlySelectors>{ConfiguratorComponent}</ConfigurationComponent>} */}
                  {isConfigurable && ConfiguratorComponent &&<div className="model-configurator-selection-accessories">{openConfigurationPopup(currentProduct, true, false)}</div>}
                </div>
                <div className={classNames(`col-8 model-configurator-results`,{"hide":activeTab!=="Products"})}>
                  <div className='product-breadcrumb-header' id="product-breadcrumb-header" style={{height:"5%"}}>
                    <BreadcrumbHeader 
                          // setBack={ this.pageCounter > 1 }
                          isIntegrated={ siteSettings.isIntegrated } 
                          pathname={ document.location.hash }
                        />
                  </div>

                  {/* prodcut list will go here*/}
                  <ProductsListComponentMemo totalFilterCount={totalFilterCount} isConfigurable={isConfigurable} view={isConfigurable?"modelconfiguratorproduct":"product"} resetHeader = {props.resetHeader} currentSelector={ currentSelector } onConfigureRequest={ onConfigureRequest } fromConfiguratorSelector={true}/>
                  {/* {ConfiguratorComponent && <ConfigurationComponent fromModelConfiguratorSelector showOnlyAccessoriesList>{ConfiguratorComponent}</ConfigurationComponent>} */}
                  { isConfigurable && ConfiguratorComponent && openConfigurationPopup(currentProduct, false, true, false)}
                </div>
              </div>
              {isConfigurable && ConfiguratorComponent && <div className="model-configurator-footer">
                {isConfigurable && ConfiguratorComponent && openConfigurationPopup(currentProduct, false, false, true)}       
              </div>}
          </div>
      </BusyContainer>
}